module.exports = __webpack_public_path__ + "img/it-question.e80d2c13.png";